import { render, staticRenderFns } from "./diagTodos.vue?vue&type=template&id=fc25bd08&"
import script from "./diagTodos.vue?vue&type=script&lang=js&"
export * from "./diagTodos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports